module.exports = __webpack_public_path__ + "static/media/tp2.bec7ed76.png";